module.exports = __webpack_public_path__ + "img/menu-mangement.7d6a3a83.svg";